/* eslint-disable react/display-name */
import React, {useContext, type ComponentType} from 'react';
import type {IStylesParams} from '../../components/ProductPage/stylesParams';

const StylesParamsContext = React.createContext<IStylesParams>({} as IStylesParams);

export function withStylesParams(Component: ComponentType, stylesParams: IStylesParams) {
  return (props: any) => {
    return (
      <StylesParamsContext.Provider value={stylesParams}>
        <Component {...props} />
      </StylesParamsContext.Provider>
    );
  };
}

export function useStylesParams() {
  return useContext(StylesParamsContext);
}
